import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const PortafolioPage = lazy(() => import('../pages/portafolio/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const EmpresaPage = lazy(() => import('../pages/empresa/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const PreciosPage = lazy(() => import('../pages/precios/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const SantiagoPage = lazy(() => import('../pages/landing-ciudad/santiago/page'));
const AricaPage = lazy(() => import('../pages/landing-ciudad/arica/page'));
const IquiquePage = lazy(() => import('../pages/landing-ciudad/iquique/page'));
const AntofagastaPage = lazy(() => import('../pages/landing-ciudad/antofagasta/page'));
const LaSerenaPage = lazy(() => import('../pages/landing-ciudad/la-serena/page'));
const VinaDelMarPage = lazy(() => import('../pages/landing-ciudad/vina-del-mar/page'));
const ConcepcionPage = lazy(() => import('../pages/landing-ciudad/concepcion/page'));
const PuertoMonttPage = lazy(() => import('../pages/landing-ciudad/puerto-montt/page'));

const BlogTendenciasPage = lazy(() => import('../pages/blog/tendencias-diseno-web-2026/page'));
const BlogSeoPage = lazy(() => import('../pages/blog/seo-2026-guia-completa/page'));
const BlogEcommercePage = lazy(() => import('../pages/blog/ecommerce-claves-del-exito/page'));
const BlogMarketingPage = lazy(() => import('../pages/blog/marketing-digital-pymes/page'));
const BlogSeguridadPage = lazy(() => import('../pages/blog/seguridad-web-protege-tu-sitio/page'));
const BlogResponsivePage = lazy(() => import('../pages/blog/responsive-design-diseno-movil/page'));
const BlogErpPage = lazy(() => import('../pages/blog/integracion-sistemas-erp/page'));
const BlogRedesSocialesPage = lazy(() => import('../pages/blog/redes-sociales-para-empresas/page'));
const BlogVelocidadPage = lazy(() => import('../pages/blog/velocidad-web-optimizacion/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/servicios', element: <ServiciosPage /> },
  { path: '/servicios/:slug', element: <ServiciosPage /> },
  { path: '/portafolio', element: <PortafolioPage /> },
  { path: '/clientes', element: <PortafolioPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/tendencias-diseno-web-2026', element: <BlogTendenciasPage /> },
  { path: '/blog/seo-2026-guia-completa', element: <BlogSeoPage /> },
  { path: '/blog/ecommerce-claves-del-exito', element: <BlogEcommercePage /> },
  { path: '/blog/marketing-digital-pymes', element: <BlogMarketingPage /> },
  { path: '/blog/seguridad-web-protege-tu-sitio', element: <BlogSeguridadPage /> },
  { path: '/blog/responsive-design-diseno-movil', element: <BlogResponsivePage /> },
  { path: '/blog/integracion-sistemas-erp', element: <BlogErpPage /> },
  { path: '/blog/redes-sociales-para-empresas', element: <BlogRedesSocialesPage /> },
  { path: '/blog/velocidad-web-optimizacion', element: <BlogVelocidadPage /> },
  { path: '/contacto', element: <ContactoPage /> },
  { path: '/empresa', element: <EmpresaPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/precios', element: <PreciosPage /> },
  { path: '/diseno-web-santiago', element: <SantiagoPage /> },
  { path: '/diseno-web-arica', element: <AricaPage /> },
  { path: '/diseno-web-iquique', element: <IquiquePage /> },
  { path: '/diseno-web-antofagasta', element: <AntofagastaPage /> },
  { path: '/diseno-web-la-serena', element: <LaSerenaPage /> },
  { path: '/diseno-web-vina-del-mar', element: <VinaDelMarPage /> },
  { path: '/diseno-web-concepcion', element: <ConcepcionPage /> },
  { path: '/diseno-web-puerto-montt', element: <PuertoMonttPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;